var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{class:[_vm.$style.block, _vm.reversed ? _vm.$style.reversed : '']},[_c('h4',{class:'line-title',attrs:{"data-anim":"stagger"},domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('p',{class:_vm.$style.content,attrs:{"data-anim":"stagger"},domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98910d5e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextBlock.vue
// module id = null
// module chunks = 